import styled from 'styled-components';

export const Wrapper = styled.div`
  flex: 1;
  display: grid;
  grid-template-columns: 510px 1fr;
  grid-template-rows: 60vh 1fr;
  grid-gap: 20px;
  grid-template-areas:
    'model meta'
    'details meta';
`;

export const Model = styled.div`
  background-color: black;
  grid-area: model;
  display: flex;
`;

export const Creator = styled.div`
  grid-area: creator;
`;

export const Details = styled.div`
  grid-area: details;
`;

export const Similar = styled.div`
  grid-area: similar;
  width: 100%;
  min-height: 50px;
`;

export const Meta = styled.div`
  grid-area: meta;
`;
